import { z } from 'zod';
/**
 * Глобальные настройки площадки — типизированная надстройка над
 * key-value таблицей `arbuz_settings` (`key text`, `value jsonb`).
 *
 * Таблица существовала с самого начала и до сих пор не читалась ни одной
 * строкой кода: сид клал в неё четыре ключа, и на этом всё заканчивалось.
 * Теперь через неё проходят два решения владельца — кто подтверждает заказ
 * и на какую карту клиент переводит деньги.
 */
/**
 * Кто подтверждает новый заказ.
 * `vendor` — исполнитель сам принимает свой заказ; админ тоже может.
 * `admin`  — заказ проходит модерацию, исполнитель ждёт.
 */
export const ORDER_CONFIRMATION_MODES = ['vendor', 'admin'];
export const orderConfirmationMode = z.enum(ORDER_CONFIRMATION_MODES);
/** То, что вправе прочитать клиент: реквизиты для перевода и телефон поддержки. */
export const publicSettings = z.object({
    card_requisites: z.string(),
    card_holder: z.string(),
    contact_phone: z.string(),
});
export const adminSettings = publicSettings.extend({
    order_confirmation_mode: orderConfirmationMode,
});
export const updateSettingsBody = z.object({
    card_requisites: z.string().max(200).optional(),
    card_holder: z.string().max(120).optional(),
    contact_phone: z.string().max(40).optional(),
    order_confirmation_mode: orderConfirmationMode.optional(),
});
//# sourceMappingURL=settings.js.map